export const round = (value: number, precision = 2): number => {
  const m = 10 ** precision
  return Math.round(value * m) / m
}
